import { useQuery } from '@apollo/client/react';
import { useAuth } from 'react-oidc-context';
import { hasAnyRelevantRole } from '../utils/user';
import { DOCTOR_ECARD_ENABLED_QUERY } from './useDoctorEcardEnabled.gql';

export const useDoctorEcardEnabled = (doctorId: string): boolean => {
  const auth = useAuth();
  const hasAnyRole = hasAnyRelevantRole(auth.user);

  const { data } = useQuery(DOCTOR_ECARD_ENABLED_QUERY, {
    variables: {
      id: doctorId,
    },
    fetchPolicy: 'cache-and-network',
    skip: !doctorId || !hasAnyRole,
  });

  return data?.doctor?.ecardEnabled === true;
};
